export default "__VITE_ASSET__n2W4baFU__"